<template>
  <div :id="uuid()" style="z-index:100 !important;width:410px"></div>
</template>
<script>
import config from '@/../config'
import wangEditor from 'wangeditor'
export default {
  name: 'formEditor',
  components: {},
  props: {
    value: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      default: () => {
        return {}
      },
    },
    debug: {
      type: Boolean,
      default: false,
    },
    zIndex: {
      type: Number,
      default: 99999,
    },
  },
  data() {
    return {
      editor: null,
      id: '',
      isInit: false,
    }
  },
  computed: {},
  watch: {
    value(val) {
      if (!this.isInit && val) {
        this.isInit = true
        this.editor.txt.html(val)
      }
    },
  },
  created() {},
  mounted() {
    this.editor = new wangEditor('#' + this.uuid())
    // 自定义菜单配置
    this.editor.config.debug = this.debug
    this.editor.config.zIndex = this.zIndex
    this.editor.config.height = 750
    this.editor.config.uploadImgTimeout = 60 * 1000
    // 配置图片 server 接口地址
    this.editor.config.uploadImgServer = config.API_HOST + '/admin/api/upload/weditor_uploadimage'
    // 配置视频 server 接口地址
    this.editor.config.uploadVideoServer = config.API_HOST + '/admin/api/upload/weditor_uploadvideo'
    // 配置菜单栏，设置不需要的菜单
    this.editor.config.excludeMenus = ['emoticon', 'code']
    // 配置全屏功能按钮是否展示
    // this.editor.config.showFullScreen = false // 全屏无法展开
    this.editor.config.showFullScreen = true
    Object.assign(this.editor.config, this.config)
    this.editor.config.onchange = (html) => {
      console.log(html)
      this.$emit('input', html)
    }
    this.editor.create()
    this.editor.txt.html(this.value)
  },
  methods: {
    getContent() {
      return this.editor.txt.text()
    },
    uuid() {
      if (!this.id) {
        this.id = 'editor_id_' + Math.ceil(Math.random() * 1000)
      }
      return this.id
    },
  },
  destroyed() {
    this.editor.txt.clear()
  },
  updated() {},
}
</script>
<style lang="less"></style>
